import { ApprenticeshipDashboard } from "~ui/templates/AdminTemplate/DashboardStats/ApprenticeshipDashboard";

export const ApprenticeshipTab = () => {
  return <ApprenticeshipDashboard />;
};
